import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('howie_geography', '/howie_geographies')
const actions = generator.generate()

export default actions
